// Action Types
import {createAction, handleActions} from "redux-actions";

const SET_FAQLIST = 'faq/SET_FAQLIST';
const SET_TOTAL = 'faq/SET_TOTAL';
const SET_SIZE = 'faq/SET_SIZE';
const SET_PAGE = 'faq/SET_PAGE';

const SET_DETAIL = 'faq/SET_DETAIL';

export const setFaqList = createAction(SET_FAQLIST);
export const setTotal = createAction(SET_TOTAL);
export const setSize = createAction(SET_SIZE);
export const setPage = createAction(SET_PAGE);
export const setDetailFaq = createAction(SET_DETAIL);



const initalState = {
    detailFaq: {
        title: '',
        content: '',
        categoryName:'',
        createdAt: '',
    },
    faqList: [],
    total: 0,
    size: 10,
    page: 1
}

export default handleActions({
    [SET_FAQLIST]: (state, action) => ({
        ...state,
        faqList: action.payload,
    }),
    [SET_TOTAL]: (state, action) => ({
        ...state,
        total: action.payload
    }),
    [SET_SIZE]: (state, action) => ({
        ...state,
        size: action.payload
    }),
    [SET_PAGE] : (state, action) => ({
        ...state,
        page: action.payload
    }),
    [SET_DETAIL]: (state, action) => ({
        ...state,
        detailFaq: {...action.payload}
    })
}, initalState);
